import React from "react";
import { CountryFlag } from "../components/global_components/CountryFlag";
import { makeFullAddress } from "./functions";

/**
 * Build full address as a component
 *
 * @param address
 * @param address2
 * @param city
 * @param state
 * @param zip
 * @param attn
 * @param countryId - if provided, display country flag
 */
export function FullAddress({
  address,
  address2,
  city,
  state,
  zip,
  attn,
  countryId,
}: {
  address?: string | null;
  address2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  attn?: string | null;
  countryId?: string | null;
}) {
  const fullAddress = makeFullAddress(address, address2, city, state, zip, attn);
  return (
    <div>
      {fullAddress} {countryId && <CountryFlag countryId={countryId} />}
    </div>
  );
}
